import { createAction, props } from '@ngrx/store';

export const setPassword = createAction('[SetPassword] SetPassword', props<{ token: string; password: string }>());

export const setPasswordSuccess = createAction('[SetPassword] SetPassword Success');

export const setPasswordFailure = createAction('[SetPassword] SetPassword Failure', props<{ error: any }>());
